import { createFileRoute } from "@tanstack/react-router";
import { TeamSettings } from "@/features/settings/team";

export const Route = createFileRoute("/_app/settings/team")({
  head: () => ({ meta: [{ title: "Team · Settings · Malfak" }] }),
  component: TeamSettings,
});
